export const UPDATE_THEME = "UPDATE_THEME";

export const SET_USER_PROFILE_DATA = "SET_USER_PROFILE_DATA";
